export default {
    GET_ALL_TICKETS_LOADING: 'GET_ALL_TICKETS_LOADING',
    GET_ALL_TICKETS_SUCCESS: 'GET_ALL_TICKETS_SUCCESS',
    GET_ALL_TICKETS_FAILED: 'GET_ALL_TICKETS_FAILED',
    GET_ALL_TICKETS_REJECT: 'GET_ALL_TICKETS_REJECT',

    GET_TICKET_DETAILS_LOADING: 'GET_TICKET_DETAILS_LOADING',
    GET_TICKET_DETAILS_SUCCESS: 'GET_TICKET_DETAILS_SUCCESS',
    GET_TICKET_DETAILS_FAILED: 'GET_TICKET_DETAILS_FAILED',
    GET_TICKET_DETAILS_REJECT: 'GET_TICKET_DETAILS_REJECT',

    REPLY_TO_MY_TICKET_LOADING: 'REPLY_TO_MY_TICKET_LOADING',
    REPLY_TO_MY_TICKET_SUCCESS: 'REPLY_TO_MY_TICKET_SUCCESS',
    REPLY_TO_MY_TICKET_FAILED: 'REPLY_TO_MY_TICKET_FAILED',
    REPLY_TO_MY_TICKET_REJECT: 'REPLY_TO_MY_TICKET_REJECT',

    SEND_NEW_TICKET_LOADING: 'SEND_NEW_TICKET_LOADING',
    SEND_NEW_TICKET_SUCCESS: 'SEND_NEW_TICKET_SUCCESS',
    SEND_NEW_TICKET_FAILED: 'SEND_NEW_TICKET_FAILED',
    SEND_NEW_TICKET_REJECT: 'SEND_NEW_TICKET_REJECT',
  };